/**
 * ============================================================
 * FEATURE FLAGS
 * ============================================================
 * ENABLE_CREDIT_SYSTEM : Active/désactive tout le système de crédits.
 *   - Quand `false` : pas de vérification de crédits, pas de déduction,
 *     pas de modal "Recharger du crédit", pas de badge de crédits.
 *   - Quand `true`  : comportement normal (vérification + déduction).
 *
 * Pour réactiver le système de crédits, il suffit de passer cette
 * constante à `true`.
 * ============================================================
 */
export const ENABLE_CREDIT_SYSTEM = true;

export const ColorPrimary = "red";

// export const bgColorPrimary = "#027AFC";
export const bgColorPrimary = "#003B7F";
export const bgColorSecondary = "#027AFC";
// export const bgColor = "#003B7F";
// 027AFC
export const errorColor = "#B3261E";

export const dividerColor = "rgba(0, 0, 0, 0.12)";

export const RADIUS = 15;
